export default [
  {
    path: "/",
    // redirect: { name: "dashboard" },
    name: "dashboard",
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Dashboard",
      layout: "dashboard",
    },
    component: () => import("@/views/Dashboard.vue"),
    beforeEach: (to, from, next) => {
      next({ name: "dashboard" });
    },
  },
  // Route "Catch-All" 404
  {
    path: "*",
    name: "404",
    meta: {
      title: "404",
      layout: "dashboard",
    },
    component: () => import("@/views/errors/404.vue"),
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Dashboard",
      layout: "dashboard",
    },
    component: () => import("@/views/Dashboard.vue"),
  },

  {
    path: "/test",
    name: "test",
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Test",
      layout: "dashboard",
    },
    component: () => import("@/views/Test.vue"),
  },
  //scan
  {
    path: "/troubleshooting",
    name: "troubleshooting",
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Scan",
      layout: "dashboard",
    },
    component: () => import("@/layouts/index/TroubleshootingIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "",
          layout: "dashboard",
        },
        path: "/",
        name: "troubleshooting-index",
        component: () => import("@/views/troubleshootings/ScanPage.vue"),
      },
    ],
  },

  //about
  {
    path: "/about",
    name: "about",
    meta: {
      is_auth: false,
      title: "About",
      layout: "default",
    },
    component: () => import("@/views/About.vue"),
  },

  // mobile router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Mobile",
      layout: "dashboard",
    },
    path: "/mobile",
    name: "mobile",
    component: () => import("@/layouts/index/MobileIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Mobile Home",
          layout: "dashboard",
        },
        path: "home",
        name: "mobile-home-index",
        component: () => import("@/views/mobiles/Home.vue"),
      },
    ],
  },

  //  backups  router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "backups",
      layout: "dashboard",
    },
    path: "/backups",
    name: "backups",
    component: () => import("@/layouts/index/BackupIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Backup",
          layout: "dashboard",
        },
        path: "index",
        name: "backups-index",
        component: () => import("@/views/backups/Listing.vue"),
      },
    ],
  },

  // settings router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "settings",
      layout: "dashboard",
    },
    path: "/settings",
    name: "settings",
    component: () => import("@/layouts/index/SettingIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "settings **",
          layout: "dashboard",
        },
        path: "index",
        name: "settings-index",
        component: () => import("@/views/settings/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "settings **",
          layout: "dashboard",
        },
        path: "create",
        name: "settings-create",
        component: () => import("@/views/settings/Create.vue"),
      },
    ],
  },
];
